import { render } from "./AnswerFormBuilder.vue?vue&type=template&id=7e2b853c&scoped=true"
import script from "./AnswerFormBuilder.vue?vue&type=script&lang=js"
export * from "./AnswerFormBuilder.vue?vue&type=script&lang=js"

import "./AnswerFormBuilder.vue?vue&type=style&index=0&id=7e2b853c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e2b853c"]])

export default __exports__